import React from "react";
import logo from "../assets/Img/airaa-logo-white.webp";
import certificate from "../assets/Pdf/IMC Membership-Certificate  26-27 ACT4031.pdf";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-blue-200 text-blue-950 py-6 px-4 text-center">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="text-left space-y-2">
          <div className="flex flex-col items-center">
            <img src={logo} alt="AIRAA Logo" width="120" height="100" loading="lazy" decoding="async" className="object-contain w-30" />
            <div className="text-center">
              <span className="text-[10px] font-semibold text-blue-900 uppercase">
                ALL INDIA RECRUITING AGENCY ASSOCIATION
              </span>
              <p className="text-[10px] text-blue-900">
                अखिल भारतीय भर्ती एजेंसी एसोसिएशन
              </p>
            </div>
          </div>
        </div>

        <div className="text-left space-y-2">
          <h3 className="text-lg font-semibold">Contact Us</h3>
          <p className="flex items-center">
            {/* <FaMapMarkerAlt className="mr-2" /> */}
            AIRAA Head Office, Mandakini, Jangid Complex Rd, Silver Park, Mira
            Road East, Mumbai, Mira Bhayandar, Maharashtra 401107
          </p>
          <p className="flex items-center">
            <FaPhone className="mr-2" /> +91 7738355865
          </p>
          <p className="flex items-center">
            <FaEnvelope className="mr-2" />{" "}
            <a href="mailto:airaa@airaa.co.in" className="underline">
              airaa@airaa.co.in
            </a>
          </p>
        </div>

        <div className="text-left space-y-2">
          <h3 className="text-lg font-semibold">Working Hours</h3>
          <p className="flex items-center">
            <FaClock className="mr-2" /> Monday - Saturday: 10:30 AM - 7:00 PM
          </p>
          <p className="flex items-center">
            <FaClock className="mr-2" /> Sunday: Closed
          </p>
          <a
            href={certificate}
            target="blank"
            className="text-blue-900 underline hover:text-blue-700 transition duration-300"
          >
            View Certificate
          </a>
        </div>
      </div>

      <div className="border-t  border-gray-700 mt-4 pt-4 text-sm">
        <p>&copy; {currentYear} AIRAA. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
